import ROLES from "../constants/roles.constants";

function userRoleIs(user, role) {
  return user.role === role;
}

function isDosenOrMahasiswa(user) {
  switch (user.role) {
    case ROLES.DOSEN:
    case ROLES.MAHASISWA:
    case ROLES.DEVELOPER:
      return true;
  }
  return false;
}

export { userRoleIs, isDosenOrMahasiswa };
